import { fetchPhpEigth } from "api"

export const guardarTracking = (url, idCotizacion, accion, paso, urlTracking) => {
    try {
        fetchPhpEigth(url, { idCotizacion, accion, paso, url: urlTracking })
    } catch (error) { }
}